import { flatten } from 'lodash-es';

export default {

  /**
   * @param error
   * @param htmlReadable
   * @returns {*}
   */
  parseErrorException(error, htmlReadable = true) {
    let errorMessages = error;
    if (this.isValidationException(error.response.data.identifier)) {
      errorMessages = this.parseValidationExceptionToReadableTextArray(
        error.response.data.data,
      );

      if (htmlReadable) {
        errorMessages = errorMessages.join('<br>');
      }
    }
    return errorMessages;
  },

  /**
   * @param errorResponse
   * @returns {Array}
   */
  parseValidationExceptionToReadableTextArray(errorResponse) {
    return flatten(Object.values(errorResponse));
  },

  /**
   * @param identifier
   * @returns {boolean}
   */
  isValidationException(identifier) {
    return identifier === 'validation_exception';
  },

  /**
   * @param identifier
   * @returns {boolean}
   */
  isNotFoundException(identifier) {
    return identifier === 'not_found' || identifier === 'entity_not_found';
  },
};



// WEBPACK FOOTER //
// ./src/utils/exceptionValidator.js